export interface ProductLabels {
	accessibilityLabel: AccessibiltyLabel;
}

export enum AccessibiltyLabel {
	BASIC = 'BASIC', // A
	COMFORT = 'COMFORT', // A+
}
